import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./actions";
import { APP_ID } from "../../utils/helpers";
import {
  GET_ALL_USER_TEST_RESULT,
  GET_PERFORMANCE_TEST_RESULT,
} from "./constants";
import Parse from "parse";

function* getPerformanceTestResultMethod({ payload }) {
  try {
    yield put(actions.getPerformanceTestResultLoading());
    const { testPtr, customerPtr } = payload;
    const qodQueryList = new Parse.Query("test_TestResult");

    qodQueryList.equalTo("AppId", {
      __type: "Pointer",
      className: "elearning_BuildConfig",
      objectId: APP_ID,
    });

    qodQueryList.equalTo("TestInfoPtr", {
      __type: "Pointer",
      className: "test_TestInfo",
      objectId: testPtr,
    });

    qodQueryList.equalTo("CustomerPtr", {
      __type: "Pointer",
      className: "elearning_Customer",
      objectId: customerPtr,
    });
    qodQueryList.include("TestInfoPtr");
    qodQueryList.include("TestAnsweredPtr");
    qodQueryList.descending("createdAt");
    const result = yield call(() => qodQueryList.first());
    if (result) {
      const parseResult = JSON.parse(JSON.stringify(result));
      yield put(actions.getPerformanceTestResultSuccess(parseResult));
    }
  } catch (error) {
    yield put(
      actions.getPerformanceTestResultError(
        error?.message || "Error occurred during performance test result."
      )
    );
  }
}

function* getAllUserTestResultMethod({ payload }) {
  try {
    yield put(actions.getAllUserTestResultLoading());
    const { testPtr } = payload;
    const qodQueryList = new Parse.Query("test_TestResult");

    qodQueryList.equalTo("AppId", {
      __type: "Pointer",
      className: "elearning_BuildConfig",
      objectId: APP_ID,
    });

    qodQueryList.equalTo("TestInfoPtr", {
      __type: "Pointer",
      className: "test_TestInfo",
      objectId: testPtr,
    });
    qodQueryList.include("TestInfoPtr");
    qodQueryList.include("TestAnsweredPtr");
    qodQueryList.descending("Percentage");
    qodQueryList.limit(2000);
    const result = yield call(() => qodQueryList.find());
    if (result) {
      const parseResult = JSON.parse(JSON.stringify(result));
      yield put(actions.getAllUserTestResultSuccess(parseResult));
    }
  } catch (error) {
    yield put(
      actions.getAllUserTestResultError(
        error?.message || "Error occurred during get all test result."
      )
    );
  }
}

export function* performanceSagas() {
  yield takeLatest(GET_PERFORMANCE_TEST_RESULT, getPerformanceTestResultMethod);
  yield takeLatest(GET_ALL_USER_TEST_RESULT, getAllUserTestResultMethod);
}
